var React = require('react');

function Home (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"matrix(1,0,0,1,-47,-110.704)"},React.createElement("g",{"transform":"matrix(1.2,0,0,1.17647,44.6,107.174)"},React.createElement("path",{"d":"M10,20L10,14L14,14L14,20L19,20L19,12L22,12L12,3L2,12L5,12L5,20L10,20Z","style":{"fill":"white","fillRule":"nonzero"}}))));
}

Home.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 24 20","version":"1.1","xmlSpace":"preserve","style":{"fillRule":"evenodd","clipRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2"}};

module.exports = Home;

Home.default = Home;
